module.exports = __webpack_public_path__ + "media/images/okra-offers/rewards-spend-02-07e8297256ecce0e1ece700b2054b6fe.png";